<template>
    <dropdown-selector
        @input="input"
        :value="value"
        :options="messageboxes"
        :keys="{ label: 'name', colour: 'colour' }"
        :disabled="disabled"
    />
</template>

<script>
    import DropdownSelector from '../elements/DropdownSelector'

    export default {
        components: { DropdownSelector },
        props: {
            value: {
                type: Object
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            input(messagebox) {
                this.$emit('input', messagebox)
            }
        },
        computed: {
            messageboxes() {
                return this.$store.getters['inbox/messageBoxes/all']
            }
        }
    }
</script>